import { axios } from '@/utils/request'
// 用户消息
export function userMessage(params) {
    return axios({
        url: '/distribution/userMessage',
        method: 'GET',
        params
    })
}
// 批量已读
export function gruopRead(data) {
    return axios({
        url: '/distribution/userMessage/reads',
        method: 'PUT',
        data
    })
}
// 批量删除
export function gruopDel(data) {
    return axios({
        url: '/distribution/userMessage',
        method: 'DELETE',
        data
    })
}
